/**
 * @see https://stackoverflow.com/a/30867255/11761617
 */
export function startsWith(
  string,
  value,
  position = 0
) {
  return string.indexOf(value, position) === position
}

export function developmentFixImageUrls(url) {
  if (process.env.VUE_APP_IMAGE_ORIGINAL_URL && process.env.VUE_APP_IMAGE_REPLACE_URL) {
    return url.replace(process.env.VUE_APP_IMAGE_ORIGINAL_URL , process.env.VUE_APP_IMAGE_REPLACE_URL )
  }
  return url
}